// Every draft write this tab has sent and not yet seen answered - so Diff &
// Validation can hold its discards and Publish until a Save that is still
// in flight has landed (otherwise the late PUT re-creates what was just
// discarded). Counted here, at the API functions every screen already
// calls, rather than per screen.
let inFlight = 0
const listeners = new Set<() => void>()

function notify() {
  for (const listener of listeners) listener()
}

export async function trackDraftWrite<T>(request: Promise<T>): Promise<T> {
  inFlight += 1
  notify()
  try {
    return await request
  } finally {
    inFlight -= 1
    notify()
  }
}

export function subscribeToDraftWrites(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function draftWritesInFlight(): number {
  return inFlight
}
